import { json, LinksFunction, LoaderArgs, MetaFunction } from '@remix-run/node'
import {
    Links,
    LiveReload,
    Meta,
    Outlet,
    Scripts,
    ScrollRestoration, useLoaderData
} from '@remix-run/react'
import { PodletLinks, PodletScripts, PodletsHandles } from '~/utils/podium'
import FavIcons from '~/components/FavIcons'



export const meta: MetaFunction = () => [
    { title: 'FINN.no - Blink' },
    { 'theme-color': '#191d3a' },
    {
        description:
            'Blink fra FINN.no: Unik markedsføring med målrettet data fra boligannonser, samler all statistikk, når 90% av Norge på én uke gjennom store mediekanaler, og øker besøk med ca. 30%. Maksimer synligheten av din boligannonse!'
    }
]

export const links: LinksFunction = () => {
    return [
        {
            rel: 'stylesheet',
            href: 'https://assets.finn.no/pkg/@fabric-ds/css/v1/fabric.min.css'
        }
    ]
}

export async function loader({ context }: LoaderArgs) {
    const { podlets, incoming, fiaasEnv } = context

    let gdprPopup = null
    if (fiaasEnv !== 'local') {
        gdprPopup = await podlets.gdprPopupPodlet.fetch(incoming);
    }

    return json({
        gdprPopup
    })
}

let podlets: PodletsHandles = ({ data }) => {
    const { gdprPopup } = data
    return [gdprPopup]
}

export let handle = {
    podlets
}

export default function App() {
    return (
        <html lang='en'>
        <head>
            <meta charSet='utf-8' />
            <meta name='viewport' content='width=device-width,initial-scale=1' />
            <Meta />
            <FavIcons />
            <PodletLinks />
            <Links />
        </head>
        <body>
        <Outlet />
        <ScrollRestoration />
        <script
            src='https://www.finn.no/injector.js'
            data-application-name='blink'
            async
        />
        <Scripts />
        <PodletScripts />
        <ConsentPopup />
        <LiveReload />
        </body>
        </html>
    )
}

function ConsentPopup() {
    const data = useLoaderData<typeof loader>()
    if (!data.gdprPopup) return null
    return <div id="gdpr-popup" dangerouslySetInnerHTML={{ __html: data.gdprPopup.content }} />
}
